import Vue from 'vue'

import IikoAPI from '@/api/iiko'

const state = {
    products_list: []
};

const mutations = {
    setIikoProducts(state, payload) {
        state.products_list = payload;
    }
};

const actions = {
    fetchProductsList(context) {
        return new Promise((resolve, reject) => {
            IikoAPI.getProductsCache(context.rootState.cafe._id).then(data => {
                context.commit('setIikoProducts', data.products);
                resolve();
            }).catch(error => {
                context.dispatch('showError', 'poster_error', {
                    root: true
                });
                reject();
            });
        });
    }
};

const getters = {
    isGroupRequired(state, getters) {
        return (iiko_id, price_group) => {
            if (!price_group.single_select) return false;

            const iiko_product = state.products_list.find(pr => pr.iiko_product_id == iiko_id);

            console.log(iiko_product);

            if (!iiko_product) return false;

            const required_modification_ids = new Set();

            //collect required modidification id from poster
            for (const group of iiko_product.price_groups) {
                if (!group.single_select) continue;

                for (const item of group.items) {
                    if (item.iiko_product_id) required_modification_ids.add(
                        item.iiko_product_id
                    );
                }
            }

            console.log(required_modification_ids);

            //check if we have any required here
            for (const item of price_group.items) {
                if (!item.iiko_product_id) continue;

                if (required_modification_ids.has(item.iiko_product_id)) {
                    return true;
                }
            }

            return false;
        };
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}